import React from 'react'

const AboutSection: React.FC = () => {
  return (
    <div className="about-content">
      <p className="story-intro">
        I've always been drawn to understanding how things work and how they could work better.
        I enjoy connecting ideas, systems, and people to create something useful and lasting.
        When I build or plan something, I think about the logic behind it and the value it can bring to others.
      </p>
      <p className="story-middle">
        I'm still early in my journey, but I like approaching projects with intention and curiosity,
        learning how design, technology, and business come together to make real impact.
        I care about clarity, purpose, and steady growth both in what I create and in myself.
      </p>
    </div>
  )
}

export default AboutSection